<p [ngClass]="{'no-margin-bottom': isLast}">
  <span>{{'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.NO_SHOW' | transloco}}: </span>
  <span>{{ buildLabelForNoShow() }}</span>
</p>
